import ArrowBottomIcon from '@/assets/svg/ui-elements/arrow-bottom.svg';
import HeaderUserIcon from '@/assets/svg/ui-elements/user-outline.svg';
import { colors } from '@/design-system/colors';
import { Skeleton } from '@/shared/components/skeleton';

import Typography from '../Typography';
import {
  ChevronWrapper,
  TriggerButton,
  TriggerContent,
  TriggerEnd,
  TriggerUserInfo,
  UserIconWrapper,
} from './UserDropdown.styled';

type OwnProps = {
  email: string;
  userName?: string;
  headshotUrl?: string;
  headshotName?: string;
  badgeLabel: string;
  badgeColor: string;
};

export type UserDropdownTriggerProps = OwnProps & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const UserDropdownTrigger = ({
  email,
  userName,
  headshotUrl,
  headshotName,
  badgeLabel,
  badgeColor,
  ...rest
}: UserDropdownTriggerProps) => (
  <TriggerButton {...rest}>
    <TriggerContent>
      <UserIconWrapper>
        {headshotUrl ? (
          <img src={headshotUrl} alt={headshotName} />
        ) : (
          <HeaderUserIcon color={colors.text.primary} />
        )}
      </UserIconWrapper>

      <TriggerUserInfo>
        {userName || email ? (
          <Typography variant="body3" fontWeight={500} color="inherit" noWrap align="left">
            {userName || email}
          </Typography>
        ) : (
          <Skeleton width={84} height={12} radius={4} lineHeight={20} />
        )}

        {badgeLabel ? (
          <Typography variant="body4" fontWeight={500} color={badgeColor} noWrap align="left">
            {badgeLabel}
          </Typography>
        ) : (
          <Skeleton width={64} height={10} radius={4} lineHeight={16} />
        )}
      </TriggerUserInfo>
    </TriggerContent>

    <TriggerEnd>
      <ChevronWrapper className="ds-chevron">
        <ArrowBottomIcon />
      </ChevronWrapper>
    </TriggerEnd>
  </TriggerButton>
);
